import { i18nColorName } from '@design-stack-vista/i18n-color-name'
import { useMemo } from 'react'

export const useI18nColorName = (color: string | undefined, locale: string): string =>
  useMemo(() => (color ? i18nColorName(color, { culture: locale, colorPalette: 'gallery' }) : ''), [color, locale])
